import { useMemo } from "react";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { DataShareService } from "@app/data-share/dataShareService";
import { DatabaseProvisionedAndPublishedStatus } from "@app/data-share/databaseProvisionedAndPublishedStatus";

export const DATA_SHARE_QUERY_KEYS = {
  clientStatus: "client-data-share-status",
} as const;

export const clientDataShareStatusQueryKey = (clientId: number | undefined): readonly [typeof DATA_SHARE_QUERY_KEYS.clientStatus, number | undefined] =>
  [DATA_SHARE_QUERY_KEYS.clientStatus, clientId] as const;

export const useGetClientDataShareStatus = (
  clientId: number | undefined,
  enabled = true,
): UseQueryResult<DatabaseProvisionedAndPublishedStatus> => {
  const dataShareService = useMemo(() => new DataShareService(), []);

  return useQuery({
    enabled: !!clientId && enabled,
    queryFn: ({ signal }) => dataShareService.getClientDatabaseProvisionedAndPublishedStatusAsync(clientId!, signal),
    queryKey: clientDataShareStatusQueryKey(clientId),
    retry: false,
  });
};
